import roleApi from '../../api/role.api';

// initial state
const state = {
  roles: {},
  perms: {},
  tenants: {},
  rolesFetched: false,
};

// getters
const getters = {
  roles: state => state.roles,
  perms: state => state.perms,
  tenants: state => state.tenants,
  rolesFetched: state => state.rolesFetched,
};

// actions
const actions = {
  getAdminRoles({ commit }, payload) {
    return roleApi.getAdminRoles(payload)
      .then((response) => {
        const {
          roles,
          permissions,
          tenants,
        } = response;
        commit('ROLES_FETCHED', true);
        commit('ROLES', roles);
        commit('PERMISSIONS', permissions);
        commit('TENANTS', tenants);
      });
  },

  getPartnerRoles({ commit }, payload) {
    return roleApi.getPartnerRoles(payload)
      .then((response) => {
        const {
          roles,
          permissions,
          tenants,
        } = response;
        commit('ROLES_FETCHED', true);
        commit('ROLES', roles);
        commit('PERMISSIONS', permissions);
        commit('TENANTS', tenants);
      });
  },
};

// mutations
const mutations = {
  ROLES_FETCHED(state, fetched) {
    state.rolesFetched = fetched;
  },
  ROLES(state, roles) {
    state.roles = roles;
  },
  PERMISSIONS(state, perms) {
    state.perms = perms;
  },
  TENANTS(state, tenants) {
    state.tenants = tenants;
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
};
